module.exports = __webpack_public_path__ + "img/53.14cba3c6.jpg";